export const SET_TIMECARD_ID = 'SET_TIMECARD_ID';
import { CREATE_TIMECARD } from '../redux/timecard';
import { SET_USER } from '../redux/user';

export const setTimecardId = (id) => {
  return {
    type: SET_TIMECARD_ID,
    payload: id,
  };
};

export const nullAction = () => {
  return {
    type: 'null',
    payload: 'null',
  };
};

const initialState = {
  timecardId: null,
};

export const general = (state = initialState, action) => {
  switch (action.type) {
    case SET_TIMECARD_ID:
      return { ...state, timecardId: action.payload };
    case SET_USER:
      let result = Object.assign({}, state);
      result.timecardId = action.payload.currentTimecardId;
      return result;
    case CREATE_TIMECARD:
      return { ...state, timecardId: action.payload.timecardId };
    default:
      return state;
  }
};
